import Axios from 'axios';
// 刷新token
export function RefreshToken() {
    return Axios.post('Account/RefreshToken', {})
        .then(res => {
            if (res.status === 200) {
                return res.data;
            } else {
                Promise.reject();
            }
        })
        .catch(err => this.$notify.error('网络异常！'));
}

export function SignIn(data) {
    return Axios.post('Account/SignIn', data)
        .then(res => {
            if (res.status === 200) {
                return res.data;
            } else {
                Promise.reject();
            }
        })
        .catch(err => this.$notify.error('网络异常！'));
}

export function GetNonce(loginid) {
    return Axios.get('Account/GetNonce', { params: { loginid } })
        .then(res => {
            if (res.status === 200) {
                return res.data;
            } else {
                Promise.reject();
            }
        })
        .catch(err => this.$notify.error('网络异常！'));
}
